import React, { useState, useEffect } from 'react';

const ProgressModal = ({ onClose, taskId }) => {
  const [progress, setProgress] = useState(33.3333);
  const [item, setItem] = useState("Unknown");

  const [maxItems, setMaxItems] = useState(0);
  const [currentItemCount, setCurrentItemCount] = useState(0);

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (taskId && taskId != "" ) {
      handleStart();
    }
    
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [taskId]);

  const handleStart = () => {
    const ws = new WebSocket(`ws://localhost:8000/progress/${taskId}`);

    ws.onopen = () => {
      console.log(`Connected to task ${taskId}`);
    };

    ws.onmessage = (event) => {
      const update = JSON.parse(event.data);
      if (update.percentage) {
        setProgress(update.percentage);
      }
      if (update.currentItem) {
        setItem(update.currentItem);
      }
      if (update.maxItems) {
        setMaxItems(update.maxItems);
      }
      if (update.count) {
        setCurrentItemCount(update.count);
      }      
      if (update.percentage >= 100) {
        ws.close();
      }
    };

    ws.onclose = () => {
      console.log(`WebSocket closed for task ${taskId}`);
    };

    setSocket(ws);
  };

  return (
    <div className="page-modal">
        <div className="modal">
            <div className="modal-content">
                <h3>Importing Items</h3>
                <p>We are now importing all the items from your selection, you can close this modal at any time as this proccess will run in the background</p>
                <br/>    

                <p>Tracking progress for Task ID: {taskId}</p><br/>
                <p>Importing: {item}</p>
                <div className="progress-container">
                    <div className="progress-bar" style={{ width: `${progress}%` }}>
                        <span className="progress-text">{progress}%</span>
                    </div>
                </div>
                <p>{currentItemCount} out of {maxItems}</p>
                <div className="modal-buttons">
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    </div>
  );
};

export default ProgressModal;
